import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getChannelInstanceId, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
import MetadataInputLabel from './MetadataInputLabel';
import { useFromAccountOptions } from '../hooks/useFromAccountOptions';
import { useUpdateFromAccount } from '../hooks/useUpdateFromAccount';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const FromAccountOption = _ref => {
  let {
      children,
      option: {
        disabled
      }
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hideTooltip = !disabled;
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      disabled: hideTooltip,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.from-account-option.option-disabled"
      }),
      children: children
    })
  }));
};
FromAccountOption.displayName = 'FromAccountOption';
function useComponent({
  inboxId,
  onChange,
  reply,
  senderField
}) {
  const replyMessage = getCommonMessage(reply);
  const messageGenericChannelId = getGenericChannelId(replyMessage);
  const value = getChannelInstanceId(replyMessage);
  const {
    options,
    loading
  } = useFromAccountOptions({
    inboxId,
    genericChannelId: messageGenericChannelId
  });
  const {
    updateFromAccount
  } = useUpdateFromAccount({
    inboxId,
    onChange,
    reply,
    senderField
  });
  return {
    options,
    isValidGenericChannelId: !!messageGenericChannelId,
    loading,
    updateFromAccount,
    value
  };
}
export function FromAccountSelect({
  inboxId,
  onChange,
  reply,
  senderField
}) {
  const {
    options,
    isValidGenericChannelId,
    loading,
    updateFromAccount,
    value
  } = FromAccountSelect.useComponent({
    inboxId,
    onChange,
    reply,
    senderField
  });
  return /*#__PURE__*/_jsx(MetadataInputLabel, {
    label: I18n.text('composer-ui.metadata-editor.sender.label'),
    children: /*#__PURE__*/_jsx(Select, {
      menuWidth: 400,
      placement: 'bottom right',
      disabled: !isValidGenericChannelId,
      buttonUse: "transparent",
      isLoading: loading,
      onChange: updateFromAccount,
      options: options,
      value: value,
      itemComponent: FromAccountOption,
      "data-selenium-test": "metadata-from-input"
    })
  });
}
FromAccountSelect.displayName = 'FromAccountSelect';
FromAccountSelect.useComponent = useComponent;